import React from 'react';

import { en } from 'localization';
import { BrandEmblem } from 'shared-components/brand';

import {
  PublicContainer,
  PublicFooterBar,
  PublicFooterBrand,
  PublicFooterLink,
  PublicFooterMeta,
  PublicFooterRow,
  PublicFooterSeparator,
  PublicFooterTagline,
} from './public-page-shell.styled-components';

const copy = en.publicShell.footer;

export const PublicFooter: React.FC = () => (
  <PublicFooterBar>
    <PublicContainer>
      <PublicFooterRow>
        <PublicFooterBrand>
          <BrandEmblem />

          <PublicFooterTagline>{copy.tagline}</PublicFooterTagline>
        </PublicFooterBrand>

        <PublicFooterMeta>
          <PublicFooterLink
            href={copy.privacyPolicyUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            {copy.privacyPolicyLabel}
          </PublicFooterLink>

          <PublicFooterSeparator aria-hidden>·</PublicFooterSeparator>

          <span>{copy.copyright}</span>
        </PublicFooterMeta>
      </PublicFooterRow>
    </PublicContainer>
  </PublicFooterBar>
);
